/*
* @描述: 订单后台管理
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-20 16:16:36
*/
<template>
    <div class="page_container">
        <CustomFormSite ref="customFormSite"
                        :can_set_show_rules="true"
                        :field_form="'purchases'"
                        :field_form_desc="'点击可对各字段单独设置，按住可拖动排序字段位置'"
                        :field_form_title="'表单预览区'"
                        :publish_btn_show="true"
                        :review_btn_show="true"
                        :review_form_type_list="reviewFormTypeList"
                        :review_dialog_width="'1120px'"
                        is_two_column
                        @submit-fields="submitFields"/>
    </div>
</template>
<script>
    import CustomFormSite from "@/components/pComponents/CustomFormSite";
    import {} from "@/api";

    export default {
        name: "PurchaseManagement",
        data() {
            return {
                tabActiveName: 'form_site',
                reviewFormTypeList: [
                    {
                        title: "电脑端",
                        value: "pc",
                        form_title: "新建采购",
                        form_desc: "模拟真实新建采购页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                    },
                    {
                        title: "移动端",
                        value: "mobile",
                        form_title: "新建采购",
                        form_desc: "模拟真实新建采购页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作",
                    },
                ],
                submitFlag: false,
                approveSiteData: []
            }
        },
        components: {CustomFormSite},
        mounted() {
        },
        methods: {
            submitFields(data) {
                this.submitFlag = false;
                if (data && data.field_list) {
                    this.submitFlag = true;
                }
                this.fieldsData = data;
                console.log(this.fieldsData);
            },


        },
    }
</script>
<style lang="scss" scoped>
</style>